module.exports = __webpack_public_path__ + "static/media/synthetic-logo@2x.c5d71c54.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/Header/synthetic-logo@2x.png
// module id = 123
// module chunks = 0